module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"EmployeeList":{"heading":"Zaměstnanci"}}}')
  delete Component.options._Ctor
}
